'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var useHackStyle = require('../hooks/useHackStyle.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const TrackingEventDescription = ({
  formattedDescription,
  description,
  s
}) => {
  const {
    cssClass
  } = useHackStyle.useHackStyle();
  const descriptionElement = formattedDescription && formattedDescription.format === 'HTML' && formattedDescription.value ? /*#__PURE__*/React__default["default"].createElement("p", {
    className: cssClass,
    style: {
      ...s,
      marginTop: '0'
    }
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: formattedDescription.value
    }
  }) : /*#__PURE__*/React__default["default"].createElement("p", {
    style: {
      ...s,
      marginTop: '0'
    }
  }, description);
  return descriptionElement;
};
var TrackingEventDescription$1 = nthHookTheme.withThemeProvider(TrackingEventDescription, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
});

exports["default"] = TrackingEventDescription$1;
